import clsx from "clsx";

import { WidgetsCategoryModel } from "@interfaces/index";
import { formatAmount } from "@utils/index";

export const WidgetItem = ({
  puEnabled,
  widget,
  onDetails,
}: {
  businessId: string;
  startDate?: string;
  endDate?: string;
  onDetails: () => void;
  widget: WidgetsCategoryModel;
  puEnabled: boolean;
}) =>
  String(widget.totalTransactionsAmount) !== "0" && (
    <button
      type="button"
      className="group flex h-40 cursor-pointer flex-col gap-y-4 rounded-lg bg-primary-108 px-6 py-4 text-black-100 hover:text-primary-300 md:h-auto"
      onClick={onDetails}
      data-testid="dashboard_itemWidget"
    >
      <div className="flex w-full items-center justify-between border-b border-b-black-8 pb-4">
        <div className="font-bold">{widget.title}</div>
        <div
          className={clsx(
            "font-bold",
            widget.type === "income" && "text-green-100",
          )}
        >
          {formatAmount(widget.totalTransactionsAmount || 0, "£")}
        </div>
      </div>
      {puEnabled && widget.business !== undefined && (
        <div className="flex w-full items-center justify-between">
          <p className="text-black-54 group-hover:text-primary-300/55">
            Business:
          </p>
          <p>{formatAmount(widget.business || 0, "£")}</p>
        </div>
      )}
      {puEnabled && widget.private !== undefined && (
        <div className="flex w-full items-center justify-between">
          <p className="text-black-54 group-hover:text-primary-300/55">
            Private:
          </p>
          <p>{formatAmount(widget.private || 0, "£")}</p>
        </div>
      )}
    </button>
  );
